import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { SafeHtmlPipe } from '@pipes/safe-html.pipe';

@Component({
  selector: 'app-dynamic-form-question-description',
  templateUrl: './dynamic-form-question-description.component.html',
  styleUrl: './dynamic-form-question-description.component.scss',
  imports: [SafeHtmlPipe],
})
export class DynamicFormQuestionDescriptionComponent implements AfterViewInit {
  @Input() public htmlDescription: string;
  @Output() public showLabFinderModal: EventEmitter<void> = new EventEmitter();

  private document = inject<Document>(DOCUMENT);

  public ngAfterViewInit(): void {
    this.setupLabFinderTriggerListener();
  }

  /**
   * Sets up the click event listener for the lab finder trigger element.
   */
  private setupLabFinderTriggerListener(): void {
    const labFinderTrigger = this.document.getElementById('lab-finder-trigger');

    if (!labFinderTrigger) {
      return;
    }

    labFinderTrigger.addEventListener('click', () => this.showLabFinderModal.emit());
  }
}
